import { useEffect, useState } from 'react';
import { useStore } from '../store';

const DIM_FROM_HOUR = 22;
const DIM_UNTIL_HOUR = 6;
const MAX_OPACITY = 0.55;

/**
 * "Nachtabsenkung". A browser cannot touch screen brightness, so this lays a
 * dark veil over the panel instead — which genuinely reduces emitted light and
 * costs nothing. True backlight control needs a native shell (Fully Kiosk's JS
 * API on Android, or an Electron/Swift wrapper).
 */
export function NightDim() {
  const enabled = useStore((s) => s.settings.nightDim);
  const [hour, setHour] = useState(() => new Date().getHours());

  useEffect(() => {
    const timer = setInterval(() => setHour(new Date().getHours()), 60_000);
    return () => clearInterval(timer);
  }, []);

  const night = hour >= DIM_FROM_HOUR || hour < DIM_UNTIL_HOUR;
  if (!enabled || !night) return null;

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: `oklch(0 0 0 / ${MAX_OPACITY})`,
        pointerEvents: 'none', // never swallow a tap
        zIndex: 40,
        transition: 'opacity 600ms',
      }}
    />
  );
}
